import React, { forwardRef, useRef, useMemo } from "react";
import { useTranslation } from "react-i18next";
import ChatLayout from "./ChatLayout";
import { Expert } from "@/models/Expert";
import useMobileDetect from "@/hooks/useMobileDetect";

interface ChatPageProps {
  contextData?: any;
  initialExpertId?: string;
  onExpertChange?: (expert: Expert) => void;
  autoScrollDisabled?: boolean;
}

/**
 * Component cho trang chat với AI
 * Bọc ChatLayout và cung cấp các props cần thiết
 */
const ChatPage: React.FC<ChatPageProps> = ({
  contextData = {},
  initialExpertId,
  onExpertChange,
  autoScrollDisabled = false,
}) => {
  const { t } = useTranslation();
  const layoutRef = useRef<any>(null);
  const { isMobile } = useMobileDetect();
  
  // Memoize context data để tránh re-render không cần thiết
  const memoizedContextData = useMemo(() => contextData, [
    contextData.availableCredits,
    contextData.userProfile,
    contextData.userId,
    // Các thuộc tính quan trọng khác nếu có
  ]);

  return (
    <div className="flex flex-col h-full overflow-hidden">
      <ChatLayout
        ref={layoutRef}
        contextData={memoizedContextData}
        initialExpertId={initialExpertId}
        onExpertChange={onExpertChange}
        fullHeight
        autoScrollDisabled={autoScrollDisabled}
        isMobileLayout={isMobile}
      />
    </div>
  );
};

export default ChatPage; 